/**
 * The message to show for a failed organisations request.
 *
 * /api/organisations answers refusals as { error: { code, message } } with a
 * message written for people, so that message is shown as it is. Anything
 * else (a network failure, a 500) gets the caller's fallback: an APIError's
 * own message is not written for people, and for these endpoints it is
 * "[object Object]".
 */
export function organisationErrorMessage(err, fallback) {
  const message = err?.data?.error?.message;
  return typeof message === 'string' && message ? message : fallback;
}

/** True when the server refused the request as not allowed (403). A group
 * that is missing or not the caller's is also 403, never 404. */
export function isForbidden(err) {
  return err?.status === 403;
}
